import { Component, Input } from '@angular/core';

@Component({
  selector: 'my-bill-show-more-button',
  templateUrl: './show-more-button.component.html',
  standalone: false,
})
export class ShowMoreButtonComponent {
  @Input() showLabelKey: string;
  @Input() hideLabelKey: string;
  @Input() buttonZone: string;
  showsMore = false;

  onClick() {
    this.showsMore = !this.showsMore;
  }
}
